function hasSeriesValues(data) {
    return Object.values(data ?? {}).some((value) => value !== null && value !== undefined);
}

export function sourceData(source, basis) {
    if (!source) {
        return {};
    }

    if (basis === "completed") {
        return source.dataNet ?? {};
    }

    return hasSeriesValues(source.dataGross) ? source.dataGross : (source.dataNet ?? source.data ?? {});
}
